import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-lock",
  "use": "rt-portal-lock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-lock\"><defs><style type=\"text/css\"></style></defs><path d=\"M880 384H764V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v144H144c-17.7 0-32 14.3-32 32v464c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v144H332V240z m508 600H184V456h656v384z\" p-id=\"2476\" fill=\"#A9C2E8\" /><path d=\"M484 661v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53c12.1-8.7 20-22.9 20-39 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 16.1 7.9 30.3 20 39z\" p-id=\"2477\" fill=\"#A9C2E8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/lock.svg
// module id = 1317
// module chunks = 72